import api from './api';
import type { Criteria, Section } from '../pages/researching-reports/intelligenceReport/criteria';
export type Cell = string | number | null;
export type ReportRow = Record<string, Cell>;
export interface Envelope { criteria: Omit<Criteria, 'filter'> & { filter: string; subjectName: string; anchors: Record<string, string> }; generatedAt: string }
export interface Pair { previous: number; current: number }
export interface MatrixRow { name: string; months: Record<string, number>; total: number }
export interface QuoteRow {
  quote: number; timesUsed: number; lastUsed: string | null; createDate: string | null; endDate: string | null;
  rateZone: string; warehouse: string; margin?: number | null;
  rates: { destination: string; parts: { amount: number; fuel: string; label: string }[] }[];
}
export interface SummaryData extends Envelope {
  header: { name: string; salesRep?: string; divisionOf?: string };
  volumeSummary: { tiles: Record<string, number>; total: number };
  revenueSummary: { revenue: number; changePct: number; marginPct?: number | null; yearly: ReportRow[] };
  storageTiles: Pair;
  charts: Record<string, Record<string, (number | null)[]>>;
}
export interface OrdersData extends Envelope {
  pies: Record<'receival' | 'movetype', { name: string; value: number }[]>;
  categoryTiles: Record<'warehouse' | 'direct' | 'ces' | 'management', Pair>;
  sslTerminalPorts?: Record<string, ReportRow[]>; domesticVolume?: ReportRow[];
  daysOut?: Record<'warehouse' | 'direct', ReportRow[]>; consignees?: MatrixRow[];
  onTime?: ReportRow[]; carriers?: ReportRow[]; representatives?: ReportRow[]; brokers?: ReportRow[]; invoiceLag?: number | null;
}
export interface Sections {
  summary: SummaryData;
  orders: OrdersData;
  warehouse: Envelope & { damages: ReportRow[]; turnover: ReportRow[]; onHand: ReportRow[]; bayUsage: ReportRow[] };
  quotes: Envelope & { direct: QuoteRow[]; warehouse: QuoteRow[]; storage: ReportRow[] };
  invoicing: Envelope & { credits?: ReportRow[]; lineItems: ReportRow[]; costBreakdown?: ReportRow[] };
  chassis: Envelope & { usage: ReportRow[]; sizes?: ReportRow[] };
  system: Envelope & { edi: ReportRow[]; gwitrack: MatrixRow[]; troubleTickets: MatrixRow[]; gwitrackWarning?: string | null };
  contacts: Envelope & { contacts: ReportRow[] };
}
const params = (c: Criteria) => ({ mode: c.mode, recno: c.recno, filter: c.filter.join(','), years: c.years, view: c.view });
export async function getSection<K extends Section>(section: K, c: Criteria, signal?: AbortSignal): Promise<Sections[K]> {
  return (await api.get<Sections[K]>(`/intelligence-report/${section}`, { params: params(c), signal })).data;
}
export async function getFilterOptions(c: Criteria, signal?: AbortSignal): Promise<{ value: number; label: string }[]> {
  return (await api.get<Envelope & { options: { value: number; label: string }[] }>('/intelligence-report/filter-options', { params: params(c), signal })).data.options;
}
